module.exports = "<div class=\"header-background\">\n\t<img class=\"header-logo\" src=\"../assets/Logo_Busso_Black.png\" height=\"57\">\t\n</div>\n\n"